import { render, staticRenderFns } from "./CarouselSmall.vue?vue&type=template&id=64d6e946&scoped=true&"
import script from "./CarouselSmall.vue?vue&type=script&lang=js&"
export * from "./CarouselSmall.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSmall.vue?vue&type=style&index=0&id=64d6e946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6e946",
  null
  
)

export default component.exports